import styles from './styles.module.css';

const WidgetCotizacionesGoogle = ({ values }) => {
    return (
        <div className={`${styles['cotizaciones-grid']}`}>
            
           <h1 className={`${styles['cotizaciones-titulo']}`}><b>Monedas, cotización de divisas</b><br />
            <span className={`${styles['cotizaciones-subtitulo']}`}>Cotizaciones, evolución, previsiones fundamentales e información para el cambio de monedas</span>
            </h1> 

            <div className={`${styles['row-titles']}`}>
                <div>Moneda</div>
                <div></div>
                <div>Compra</div>
                <div>Venta</div>
                <div>Variación</div>
            </div>
            {Array.isArray(values) && values?.map((c) => {
                return <div className={`${styles['row-values']}`} key={c.etiqueta}>
                    <div className={`${styles['strong']}`}>Moneda:</div>
                    <div className={`${styles['strong']}`}><a href={`monedas/${c.moneda}`}>{c.etiqueta}</a>
                    {(c?.moneda?.includes("byma")||c?.moneda?.includes("ccl"))  && <span className={`${styles['cotizaciones-byma-asterisco']}`}> (*)</span>}</div>
                    <div className={`${styles['strong']}`}> Fecha/Última Actualización:</div>
                    <div></div>
                    <div className={`${styles['strong']}`}>Compra:</div>
                    <div>{c.compra? c.simbolo : ''}{c.compra}</div>
                    <div className={`${styles['strong']}`}>Venta:</div>
                    <div>{c.venta? c.simbolo: ''}{c.venta}</div>
                    <div className={`${styles['strong']}`}>Variación:</div>
                     { c.variacion !== undefined && (<div className={parseFloat(c.variacion || 0) > 0 ? styles['variacion-suba'] : styles['variacion-baja']
}>{`${c.variacion}`}%</div>
            )}
         
                </div>
                
            })}
            <div className={`${styles['cotizaciones-firma']}`}>
            Datos provistos por BYMA (*)
            <img src="https://www.ellitoral.com/collections/utiles-diseno/logo-byma-firma___67b76973215744001a6c129d.png" title="byma"/></div>
        </div>
    )
}

export default WidgetCotizacionesGoogle;